var leadForm = {
  submitButton: $('#lead_submit'),
  phoneInput: $('#lead_phoneNumber'),
  nameInput: $('#lead_fullName'),
  emailInput: $('#lead_email'),
  partnerInput: $('#lead_partner'),
  purchasePriceInput: $('#lead_purchasePrice'),
  submitOnChange: $('.lead-submit-on-change'),
  upperCase: $('.uppercase'),
  onlyNumbers: $('.only-numbers'),
  formatNumbers: $('.format-numbers'),
  removeSpace: $('.remove-space'),

  init: function () {
    this.form = this.submitButton.closest('form');
    toastr.options.positionClass = 'toast-top-right';

    var widget = this.form.find('[data-toggle="recaptcha"]')[0];
    if (widget) {
      var widgetType = widget.getAttribute('data-type');
      var widgetSiteKey = widget.getAttribute('data-site-key');
      var widgetParameters = {
        sitekey: widgetSiteKey,
      };
      if (widgetType == 'invisible') {
        widgetParameters['callback'] = function () {
          app.submitForm(app.form.serialize());
        };
        widgetParameters['size'] = 'invisible';
      }
      var widgetId = grecaptcha.render(widget, widgetParameters);
    }

    var app = this;
    this.submitOnChange.on('change', function (event) {
      switch (event.target.id) {
        case app.nameInput.attr('id'): {
          app.nameInput.parent().find($('.form-error')[0]).remove();
          if (!app.checkName(app.nameInput)) {
            event.preventDefault();
            app.nameInput
              .parent()
              .append(
                '<div class="form-error"><ul><li>' +
                  app.nameInput.data('fullname-error') +
                  '</li></ul></div>'
              );
          }
          break;
        }
        case app.partnerInput.attr('id'): {
          app.partnerInput.parent().find($('.form-error')[0]).remove();
          if (!app.checkName(app.partnerInput)) {
            event.preventDefault();
            app.partnerInput
              .parent()
              .append(
                '<div class="form-error"><ul><li>' +
                  app.partnerInput.data('partner-error') +
                  '</li></ul></div>'
              );
          }
          break;
        }
        case app.emailInput.attr('id'): {
          if (app.emailInput.parent().find('.form-error').length) {
            app.emailInput.parent().find('.form-error')[0].remove();
          }
          if (!app.checkEmail(app.emailInput)) {
            event.preventDefault();
            app.emailInput
              .parent()
              .append(
                '<div class="form-error"><ul><li>' +
                  app.emailInput.data('email-error') +
                  '</li></ul></div>'
              );
          }
          break;
        }
        case app.phoneInput.attr('id'): {
          if (app.phoneInput.parent().parent().find('.form-error').length) {
            app.phoneInput.parent().parent().find('.form-error')[0].remove();
          }
          if (!app.checkPhoneNumber(app.phoneInput)) {
            event.preventDefault();
            app.phoneInput
              .parent()
              .parent()
              .append(
                '<div class="form-error"><ul><li>' +
                  app.phoneInput.data('phone-error') +
                  '</li></ul></div>'
              );
          }
          break;
        }
        case app.purchasePriceInput.attr('id'): {
          if (app.purchasePriceInput.parent().find('.form-error').length) {
            app.purchasePriceInput.parent().find('.form-error')[0].remove();
          }
          if (!app.checkIsEmpty(app.purchasePriceInput)) {
            event.preventDefault();
            app.purchasePriceInput
              .parent()
              .append(
                '<div class="form-error"><ul><li>' +
                  app.purchasePriceInput.data('purchaseprice-error') +
                  '</li></ul></div>'
              );
          }
          break;
        }
      }
    });
    this.submitButton.on('click', function (event) {
      $('.form-error').remove();
      if (!app.checkName(app.nameInput)) {
        event.preventDefault();
        app.nameInput
          .parent()
          .append(
            '<div class="form-error"><ul><li>' +
              app.nameInput.data('fullname-error') +
              '</li></ul></div>'
          );
        return;
      }
      if (!app.checkName(app.partnerInput)) {
        event.preventDefault();
        app.partnerInput
          .parent()
          .append(
            '<div class="form-error"><ul><li>' +
              app.partnerInput.data('partner-error') +
              '</li></ul></div>'
          );
        return;
      }
      if (!app.checkEmail(app.emailInput)) {
        event.preventDefault();
        app.emailInput
          .parent()
          .append(
            '<div class="form-error"><ul><li>' +
              app.emailInput.data('email-error') +
              '</li></ul></div>'
          );
        return;
      }
      if (!app.checkPhoneNumber(app.phoneInput)) {
        event.preventDefault();
        app.phoneInput
          .parent()
          .parent()
          .append(
            '<div class="form-error"><ul><li>' +
              app.phoneInput.data('phone-error') +
              '</li></ul></div>'
          );
        return;
      }
      if (!app.checkIsEmpty(app.purchasePriceInput)) {
        event.preventDefault();
        app.purchasePriceInput
          .parent()
          .append(
            '<div class="form-error"><ul><li>' +
              app.purchasePriceInput.data('purchaseprice-error') +
              '</li></ul></div>'
          );
        return;
      }
      if (app.form[0].checkValidity()) {
        event.preventDefault();
        var checkbox = $('#checkbox');
        $('.form-error').remove();
        if (checkbox.prop('checked')) {
          // app.submitForm(app.form.serialize());
          grecaptcha.execute(widgetId);
        } else {
          $('.form-label--agree')
            .parent()
            .append(
              '<span class="form-error"><ul><li>' +
                checkbox.data('error') +
                '</li></ul></span>'
            );
        }
      }
    });
    this.upperCase.keyup(function () {
      $(this).val($(this).val().toUpperCase());
    });
    this.onlyNumbers.keyup(function () {
      $(this).val($(this).val().replace(/\D/g, ''));
    });
    this.formatNumbers.keyup(function () {
      $(this).val($(this).val().replace(/\D/g, ''));
    });
    this.removeSpace.keyup(function () {
      $(this).val($(this).val().replace(/\s/g, ''));
    });
  },
  checkFormData: function () {},
  submitForm: function (serializedForm) {
    var app = this;
    $.ajax({
      url: this.form.attr('action'),
      method: 'POST',
      data: serializedForm,
      beforeSend: function () {
        app.disableButton(true);
      },
      success: function (response) {
        if (response.ok) {
          app.showMessage(response.message, 'success');
          $('#contact-modal').removeClass('modal--show');
          $('body').removeClass('modal-open');
        } else {
          app.showMessage(response.message, 'warning');
        }
      },
      error: function (response) {
        app.showMessage(response.responseJSON.message, 'error');
      },
      complete: function () {
        app.enableButton();
        app.form[0].reset();
      },
    });
  },
  showMessage: function (message, type) {
    toastr[type](message);
  },
  disableButton: function () {
    this.submitButton.attr('disabled', 'disabled');
  },
  enableButton: function () {
    this.submitButton.attr('disabled', false);
  },
  checkPhoneNumber: function (element) {
    var phoneNumber = element.val();
    var firstNumber = phoneNumber.substring(0, 1);

    var isnum = /^\d+$/.test(phoneNumber);

    if (
      phoneNumber.length !== 9 ||
      (firstNumber !== '6' &&
        firstNumber !== '7' &&
        firstNumber !== '8' &&
        firstNumber !== '9') ||
      !isnum
    ) {
      return false;
    }

    return true;
  },
  checkEmail: function (element) {
    return String(element.val())
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  },
  checkName: function (element) {
    return element.val();
  },
  checkIsEmpty: function (element) {
    return element.val();
  },
};

function onloadLeadCallback() {
  leadForm.init();
}
